'use client'

import { useEffect, useRef } from 'react'
import { trackModelShowcaseScrolled } from '@/lib/analytics'

const THRESHOLDS = [50, 90]

/** Reports how far down the page people actually get. Renders nothing. */
export function ScrollDepthTracker({ model }: { model: string }) {
  const fired = useRef<Set<number>>(new Set())

  useEffect(() => {
    const report = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight
      if (scrollable <= 0) return
      const percent = (window.scrollY / scrollable) * 100
      for (const threshold of THRESHOLDS) {
        if (percent >= threshold && !fired.current.has(threshold)) {
          fired.current.add(threshold)
          trackModelShowcaseScrolled({ model, depthPercent: threshold })
        }
      }
    }

    window.addEventListener('scroll', report, { passive: true })
    report()
    return () => window.removeEventListener('scroll', report)
  }, [model])

  return null
}
